let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("higkU")).then(() => parcelRequire('ftr2N'));